// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { dspProcessingId } from './DspProcessing';
import { fractionTypeEnum26cb99fd } from './FractionTypeEnum26cb99fd';
import { z } from 'zod';
export const sampleMetadataId = (z.number());
export const sampleMetadata = z.object({
    id: sampleMetadataId,
    dsp_processing_id: dspProcessingId,
    colour: z.string(),
    smell: z.string(),
    taste: z.string(),
    foaming: z.string(),
    emulsification: z.string(),
    heat_gelling: z.string(),
    acid_gelling: z.string(),
    solubility: z.string(),
    fraction_type: fractionTypeEnum26cb99fd.nullable(),
    created_at: z.date(),
});
export const sampleMetadataInitializer = z.object({
    id: sampleMetadataId.optional(),
    dsp_processing_id: dspProcessingId,
    colour: z.string(),
    smell: z.string(),
    taste: z.string(),
    foaming: z.string(),
    emulsification: z.string(),
    heat_gelling: z.string(),
    acid_gelling: z.string(),
    solubility: z.string(),
    fraction_type: fractionTypeEnum26cb99fd.optional().nullable(),
    created_at: z.date().optional(),
});
export const sampleMetadataMutator = z.object({
    id: sampleMetadataId.optional(),
    dsp_processing_id: dspProcessingId.optional(),
    colour: z.string().optional(),
    smell: z.string().optional(),
    taste: z.string().optional(),
    foaming: z.string().optional(),
    emulsification: z.string().optional(),
    heat_gelling: z.string().optional(),
    acid_gelling: z.string().optional(),
    solubility: z.string().optional(),
    fraction_type: fractionTypeEnum26cb99fd.optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=SampleMetadata.js.map